import { Field, Formik } from "formik";
import React, { Component } from "react";
import { Translation, withTranslation } from "react-i18next";
import { withRouter } from "react-router";
import { toast } from "react-toastify";
import { getUserDetails, updateUserDetails } from "../../constants/apiParams";
import apiCall, { METHOD } from "../../constants/baseUrl";
import { getUserID } from "../../util/utils";
import { ManageProfileSchema } from "../../util/validationSchema";
import ErrorMessageFormik from "../CommanComponents/ErrorMessageFormik";

 class ManageProfile extends Component {
   constructor(props) {
     super(props);

     this.state = {
       isLoading: false,
       name:'',
       email:'',
       first_name:'',
     };
   }



   componentDidMount() {

       apiCall(
         METHOD.QUERY,
         getUserDetails(
           getUserID(),
         ),
         (data) => {
           this.getProfileResponse(data);
         },
         (isLoading) => {
         },
      (data) => {
        toast.error(this.props.t(data.message));
      }
       );
   }
   
   getProfileResponse = (data) => {
     const { name, first_name, email } = data
     
     this.setState({
       name,
       email,
       first_name
     })
   }
   handleSubmit = (values) => {
     const { name,first_name,email } = values;
     apiCall(
       METHOD.QUERY,
       updateUserDetails(getUserID(), email, name, first_name),
       (data) => {
         toast.success(this.props.t(data.message));
         let { from } = this.props.location.state || {
           from: { pathname: "/" },
         };
         this.props.history.push(from);
       },
       (isLoading) => {
         this.setState({ isLoading });
       },
      (data) => {
        toast.error(this.props.t(data.message));
      }
     );
   };
   render() {
     const { isLoading ,name,email,first_name} = this.state;
     return (
       <Translation ns="translation">
         {(t, { i18n }) => {
           return (
             <div className="wrapper position-relative">
               <Formik
                 enableReinitialize
                 initialValues={{
                   name: name ? name : "",
                   email: email ? email : "",
                   first_name: first_name ? first_name : "",
                 }}
                 validationSchema={ManageProfileSchema(
                   t("manageProfile.first_name_error"),
                   t("manageProfile.name_error"),
                   t("manageProfile.email_error"),
                   t("manageProfile.email_valid_error")
                 )}
                 onSubmit={(values) => {
                   this.handleSubmit(values);
                 }}
               >
                 {({ handleSubmit }) => (
                   <React.Fragment>
                     <div className="header-bg header-blue sab-header1 sticky-top">
                       <div className="container">
                         <div className="py-2 d-flex align-items-center">
                           <span
                             className="pointer"
                             onClick={() => {
                               let { from } = this.props.location.state || {
                                 from: { pathname: "/" },
                               };
                               this.props.history.push(from);
                             }}
                           >
                             <i className="zmdi zmdi-close zmdi-hc-fw font-30 text-light"></i>
                           </span>
                         </div>
                         <div className="text-center mt-4 text-light">
                           <h2 className="m-0 text-light">
                             {t("manageProfile.title")}
                           </h2>
                         </div>
                       </div>
                     </div>
                     <div className="middle-section sab-middle-section1">
                       <div className="container my-4 00z-index-99">
                         <form>
                           <div className="form-group">
                             <label className="font-14">
                               {t("manageProfile.first_name")}
                             </label>
                             <Field
                               type="text"
                               name="first_name"
                               placeholder={t(
                                 "manageProfile.first_name_placeholder"
                               )}
                               className="form-control"
                               required
                             />
                             <ErrorMessageFormik name="first_name" />
                           </div>

                           <div className="form-group">
                             <label className="font-14">
                               {t("manageProfile.name")}
                             </label>
                             <Field
                               type="text"
                               name="name"
                               placeholder={t("manageProfile.name")}
                               className="form-control"
                               required
                             />
                             <ErrorMessageFormik name="name" />
                           </div>

                           <div className="form-group">
                             <label className="font-14">
                               {t("manageProfile.email")}
                             </label>
                             <Field
                               type="text"
                               name="email"
                               placeholder={t(
                                 "manageProfile.email_placeholder"
                               )}
                               className="form-control"
                               required
                             />
                             <ErrorMessageFormik name="email" />
                           </div>

                           <div className="form-group text-center mt-4">
                             {isLoading ? (
                               <button
                                 type="button"
                                 onClick={handleSubmit}
                                 className="btn btn-success btn-block"
                               >
                                 {t("manageProfile.update_profile")}

                                 <div className="spinner-border spinner-border-sm ml-1 text-white">
                                   <span className="sr-only">
                                     {t("GeneralMessages.loading")}
                                   </span>
                                 </div>
                               </button>
                             ) : (
                               <button
                                 type="button"
                                 onClick={handleSubmit}
                                 className="btn btn-success btn-block"
                               >
                                 {t("manageProfile.update_profile")}
                               </button>
                             )}
                           </div>
                         </form>
                       </div>
                     </div>
                   </React.Fragment>
                 )}
               </Formik>
             </div>
           );
         }}
       </Translation>
     );
   }
 }
export default withTranslation()(withRouter(ManageProfile));
